import * as Yup from "yup";
import { AddressInputSchema } from "../common/SharedAddressInput/schemas";
import { createEntityInformationInputSchema } from "../EntityInformationInput/schemas";
import { Question } from "../EntityTypeSurvey/types";
import { EntityProfileFormValues } from "./types";

const createFullEntitySchema = (
  values: EntityProfileFormValues,
): Yup.ObjectSchema<EntityProfileFormValues> => {
  const baseSchema = Yup.object({
    ...createEntityInformationInputSchema.fields,
    ...AddressInputSchema.fields,
  });

  const hasQuestionsInForm =
    values.updatedQuestions &&
    Array.isArray(values.updatedQuestions) &&
    values.updatedQuestions.length > 0;

  if (hasQuestionsInForm) {
    return baseSchema.shape({
      updatedQuestions: Yup.array()
        .of(
          Yup.object({
            id: Yup.string().required(),
            question: Yup.string().required(),
            answer: Yup.string(),
          }),
        )
        .test(
          "questions-validation",
          "All required fields and questions must be completed",
          (questions?: Question[]) => {
            if (!questions) return false;
            const questionAnsweredAffirmatively = questions.some(
              (question) => question.answer === "Yes",
            );
            const allQuestionsAnsweredNegatively = questions.every(
              (question) => question.answer === "No",
            );
            return questionAnsweredAffirmatively || allQuestionsAnsweredNegatively;
          },
        )
        .required(),
    }) as Yup.ObjectSchema<EntityProfileFormValues>;
  }

  // If no questions in form, questions field is optional
  return baseSchema.shape({
    updatedQuestions: Yup.array().notRequired(),
  }) as Yup.ObjectSchema<EntityProfileFormValues>;
};

export const createEntityProfileSchema = (): Yup.ObjectSchema<EntityProfileFormValues> => {
  const lazySchema = Yup.lazy((values: EntityProfileFormValues) => {
    return createFullEntitySchema(values);
  });

  // TypeScript requires a two-step assertion for Yup.lazy to ObjectSchema conversion
  // This is safe because Yup.lazy returns a schema compatible with form validation
  return lazySchema as unknown as Yup.ObjectSchema<EntityProfileFormValues>;
};
